import { pgTable, text, boolean, timestamp, integer, index, foreignKey } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { repeatType } from './enums';
import { user } from './user';

export const goal = pgTable('Goal', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  userId: integer().notNull(),
  isPublic: boolean().default(false).notNull(),
  isCompleted: boolean().default(false).notNull(),
  deadline: timestamp({ precision: 3, mode: 'date' }),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
}, (table) => [
  index('Goal_isCompleted_idx').using('btree', table.isCompleted.asc().nullsLast()),
  index('Goal_isPublic_idx').using('btree', table.isPublic.asc().nullsLast()),
  index('Goal_userId_idx').using('btree', table.userId.asc().nullsLast()),
  foreignKey({
    columns: [table.userId],
    foreignColumns: [user.id],
    name: 'Goal_userId_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);

export const intention = pgTable('Intention', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  userId: integer().notNull(),
  text: text().notNull(),
  isCompleted: boolean().default(false).notNull(),
  isPublished: boolean().default(false).notNull(),
  proofUrl: text(),
  comment: text(),
  expiresAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
}, (table) => [
  index('Intention_expiresAt_idx').using('btree', table.expiresAt.asc().nullsLast()),
  index('Intention_isCompleted_idx').using('btree', table.isCompleted.asc().nullsLast()),
  index('Intention_userId_idx').using('btree', table.userId.asc().nullsLast()),
  foreignKey({
    columns: [table.userId],
    foreignColumns: [user.id],
    name: 'Intention_userId_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);

export const reminder = pgTable('Reminder', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  userId: integer().notNull(),
  repeatType: repeatType().default('ONCE').notNull(),
  repeatDays: integer().array(),
  repeatTime: text().array(),
  endDate: timestamp({ precision: 3, mode: 'date' }),
  isCompleted: boolean().default(false).notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
}, (table) => [
  index('Reminder_isCompleted_idx').using('btree', table.isCompleted.asc().nullsLast()),
  index('Reminder_repeatType_idx').using('btree', table.repeatType.asc().nullsLast()),
  index('Reminder_userId_idx').using('btree', table.userId.asc().nullsLast()),
  foreignKey({
    columns: [table.userId],
    foreignColumns: [user.id],
    name: 'Reminder_userId_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);

export const reminderHistory = pgTable('ReminderHistory', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  reminderId: integer().notNull(),
  completedAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  index('ReminderHistory_completedAt_idx').using('btree', table.completedAt.asc().nullsLast()),
  index('ReminderHistory_reminderId_idx').using('btree', table.reminderId.asc().nullsLast()),
  foreignKey({
    columns: [table.reminderId],
    foreignColumns: [reminder.id],
    name: 'ReminderHistory_reminderId_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);

export const reminderLog = pgTable('ReminderLog', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  reminderId: integer().notNull(),
  scheduledAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
  sentAt: timestamp({ precision: 3, mode: 'date' }),
  status: text().notNull(), // 'SENT' | 'FAILED' | 'SKIPPED'
  errorMessage: text(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  index('ReminderLog_reminderId_idx').using('btree', table.reminderId.asc().nullsLast()),
  index('ReminderLog_scheduledAt_idx').using('btree', table.scheduledAt.asc().nullsLast()),
  index('ReminderLog_status_idx').using('btree', table.status.asc().nullsLast()),
  foreignKey({
    columns: [table.reminderId],
    foreignColumns: [reminder.id],
    name: 'ReminderLog_reminderId_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);
